// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"1949acff","693":"e697be22"}[chunkId] + ".chunk.js";
};